export default __webpack_public_path__ + "static/media/IMG_2271cropped.d89960ea.jpeg";